(function () {
  'use strict';

  function slug(s) {
    return (s || '').toLowerCase().trim();
  }

  // True if the current URL has any native Shopify filter param (filter.* or q/price).
  // Used to detect a "cleared" collection so we can wipe client-side occasion/tag state.
  function hasNativeFilters() {
    var s = window.location.search || '';
    if (!s) return false;
    // Shopify filter params look like filter.v.*, filter.p.*, etc.
    if (s.indexOf('filter.') !== -1) return true;
    return false;
  }

  function setup(root) {
    var occRoot = root.querySelector('[data-zwc-occasion-root]');
    var tagRoot = root.querySelector('[data-zwc-tags-root]');

    // activeOccasions / activeTags persist across AJAX grid/sidebar swaps because
    // they live on the root element, not in a closure that gets wiped on rerender.
    // Both are arrays (multi-select, OR logic).
    if (!root._zwcOccasions) root._zwcOccasions = [];
    if (!root._zwcTags) root._zwcTags = [];

    // --- Re-apply hide/show + counts against the CURRENT grid ---
    function scanCards() {
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-zwc-card]'));
      return cards.map(function (card) {
        var item = card.closest('.zwc-card-wrap') || card;
        var raw = slug(card.getAttribute('data-zwc-product-colls'));
        var list = raw.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
        // Product tags live on the wrapper (stamped by the section), not the card.
        var rawTags = slug(item.getAttribute('data-zwc-tags'));
        var tags = rawTags.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
        return { item: item, colls: list, tags: tags };
      });
    }

    function cardInColl(c, handle) {
      return c.colls.indexOf(handle) !== -1;
    }

    function cardHasTag(c, tag) {
      return c.tags.indexOf(tag) !== -1;
    }

    // OR logic: card matches if it's in AT LEAST ONE selected occasion collection.
    function cardHasAnyOccasion(c, occs) {
      if (!occs.length) return true;
      for (var i = 0; i < occs.length; i++) {
        if (cardInColl(c, occs[i])) return true;
      }
      return false;
    }

    // OR logic: card matches if it carries AT LEAST ONE selected tag.
    function cardHasAnyTag(c, tags) {
      if (!tags.length) return true;
      for (var i = 0; i < tags.length; i++) {
        if (cardHasTag(c, tags[i])) return true;
      }
      return false;
    }

    // Combined: (any selected occasion) AND (any selected tag).
    function cardMatches(c, occs, tags) {
      if (!cardHasAnyOccasion(c, occs)) return false;
      if (!cardHasAnyTag(c, tags)) return false;
      return true;
    }

    function updateCounts(cardData) {
      var occs = root._zwcOccasions || [];
      var tags = root._zwcTags || [];

      if (occRoot) {
        occRoot.querySelectorAll('[data-zwc-occasion]').forEach(function (btn) {
          var h = slug(btn.getAttribute('data-zwc-occasion'));
          var countEl = btn.querySelector('[data-zwc-occasion-count]');
          if (!countEl) return;
          var n = 0;
          cardData.forEach(function (c) {
            if (cardHasAnyTag(c, tags) && cardInColl(c, h)) n++;
          });
          countEl.textContent = '(' + n + ')';
        });
      }

      if (tagRoot) {
        tagRoot.querySelectorAll('[data-zwc-tag]').forEach(function (btn) {
          var t = slug(btn.getAttribute('data-zwc-tag'));
          var countEl = btn.querySelector('[data-zwc-tag-count]');
          if (!countEl) return;
          var n = 0;
          cardData.forEach(function (c) {
            if (cardHasAnyOccasion(c, occs) && cardHasTag(c, t)) n++;
          });
          countEl.textContent = '(' + n + ')';
        });
      }
    }

    /* =========================================================
       ACTIVE-FILTER PILLS for occasion/tag selections.
       The Liquid pills only cover native Shopify filters, so we
       inject matching pills for client-side selections. If NO
       native filter is active (Liquid didn't render the section),
       we build the whole ACTIVE FILTERS block ourselves and mark
       it data-zwc-client-active so we can remove it again.
    ========================================================= */
    function pillXSvg() {
      return '<svg width="9" height="9" viewBox="0 0 9 9" fill="none"><path d="M1 1L8 8M8 1L1 8" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>';
    }

    // Read the human label off the live sidebar button; fall back to the raw value.
    function findLabel(kind, value) {
      var sel = kind === 'occasion' ? '[data-zwc-occasion]' : '[data-zwc-tag]';
      var attr = kind === 'occasion' ? 'data-zwc-occasion' : 'data-zwc-tag';
      var lblSel = kind === 'occasion' ? '.zwc-occasion-label' : '.zwc-tag-label';
      var btns = root.querySelectorAll(sel);
      for (var i = 0; i < btns.length; i++) {
        if (slug(btns[i].getAttribute(attr)) === value) {
          var l = btns[i].querySelector(lblSel);
          if (l) return l.textContent.trim();
        }
      }
      return value;
    }

    function makePill(kind, value) {
      var a = document.createElement('a');
      a.href = '#';
      a.className = 'zwc-active-pill';
      a.setAttribute('data-zwc-client-pill', '');
      a.setAttribute('data-zwc-pill-kind', kind);
      a.setAttribute('data-zwc-pill-value', value);
      a.setAttribute('data-zwc-stop', '');
      var t = document.createElement('span');
      t.className = 'zwc-active-pill-text';
      t.textContent = findLabel(kind, value);
      var x = document.createElement('span');
      x.className = 'zwc-active-pill-x';
      x.setAttribute('aria-hidden', 'true');
      x.innerHTML = pillXSvg();
      a.appendChild(t);
      a.appendChild(x);
      return a;
    }

    function syncPills() {
      var panel = root.querySelector('.zwc-filter-panel');
      if (!panel) return;
      var occs = root._zwcOccasions || [];
      var tags = root._zwcTags || [];
      var section = panel.querySelector('[data-zwc-active-section]');
      var pillsWrap = section ? section.querySelector('.zwc-active-pills') : null;

      // Remove our previous client pills (native pills stay untouched)
      if (pillsWrap) {
        Array.prototype.slice.call(pillsWrap.querySelectorAll('[data-zwc-client-pill]')).forEach(function (p) {
          p.remove();
        });
      }

      if (!occs.length && !tags.length) {
        // Nothing client-side selected → tear down the block only if WE built it
        if (section && section.hasAttribute('data-zwc-client-active')) section.remove();
        return;
      }

      if (!section) {
        section = document.createElement('div');
        section.className = 'zwc-active-section';
        section.setAttribute('data-zwc-active-section', '');
        section.setAttribute('data-zwc-client-active', '');

        var head = document.createElement('div');
        head.className = 'zwc-active-head';
        var lbl = document.createElement('span');
        lbl.className = 'zwc-active-label';
        lbl.textContent = 'ACTIVE FILTERS';
        var clr = document.createElement('a');
        clr.className = 'zwc-active-clear';
        clr.setAttribute('data-zwc-clear', '');
        var existingClear = root.querySelector('[data-zwc-clear]');
        clr.href = existingClear ? (existingClear.getAttribute('href') || window.location.pathname) : window.location.pathname;
        clr.textContent = 'Clear';
        head.appendChild(lbl);
        head.appendChild(clr);

        pillsWrap = document.createElement('div');
        pillsWrap.className = 'zwc-active-pills';

        section.appendChild(head);
        section.appendChild(pillsWrap);

        var body = panel.querySelector('.zwc-filter-body');
        if (body) panel.insertBefore(section, body);
        else panel.appendChild(section);

        // The new Clear link must also wipe client state
        bindClears();
      } else if (!pillsWrap) {
        pillsWrap = document.createElement('div');
        pillsWrap.className = 'zwc-active-pills';
        section.appendChild(pillsWrap);
      }

      occs.forEach(function (h) { pillsWrap.appendChild(makePill('occasion', h)); });
      tags.forEach(function (t) { pillsWrap.appendChild(makePill('tag', t)); });
    }

    function apply() {
      var occs = root._zwcOccasions || [];
      var tags = root._zwcTags || [];
      var cardData = scanCards();
      var emptyMsg = root.querySelector('[data-zwc-occasion-empty]');
      var pagination =
        root.querySelector('[data-zwc-pagination]') ||
        root.querySelector('.zwc-pagination') ||
        root.querySelector('.pagination');

      var active = occs.length > 0 || tags.length > 0;
      var shown = 0;
      cardData.forEach(function (c) {
        var match = cardMatches(c, occs, tags);
        if (match) {
          c.item.style.removeProperty('display');
          shown++;
        } else {
          c.item.style.setProperty('display', 'none', 'important');
        }
      });

      if (occRoot) {
        occRoot.querySelectorAll('[data-zwc-occasion]').forEach(function (btn) {
          var h = slug(btn.getAttribute('data-zwc-occasion'));
          btn.classList.toggle('is-active', occs.indexOf(h) !== -1);
        });
      }
      if (tagRoot) {
        tagRoot.querySelectorAll('[data-zwc-tag]').forEach(function (btn) {
          var t = slug(btn.getAttribute('data-zwc-tag'));
          btn.classList.toggle('is-active', tags.indexOf(t) !== -1);
        });
      }

      updateCounts(cardData);
      syncPills();

      if (emptyMsg) emptyMsg.hidden = !(active && shown === 0);
      if (pagination) pagination.style.display = active ? 'none' : '';
    }

    // Expose apply so the document-level pill-remove handler can re-run this root.
    root._zwcOccApply = apply;

    // Reset all client-side selections (occasion + tags) and re-apply.
    function clearAll() {
      root._zwcOccasions = [];
      root._zwcTags = [];
      apply();
    }

    // --- Bind occasion buttons (multi-select toggle, OR logic) ---
    function bindOccasion() {
      var live = root.querySelector('[data-zwc-occasion-root]');
      if (!live) return;
      occRoot = live;
      var buttons = Array.prototype.slice.call(live.querySelectorAll('[data-zwc-occasion]'));
      buttons.forEach(function (btn) {
        if (btn._zwcBound) return;
        btn._zwcBound = true;
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
          var handle = slug(btn.getAttribute('data-zwc-occasion'));
          var idx = root._zwcOccasions.indexOf(handle);
          if (idx === -1) root._zwcOccasions.push(handle);
          else root._zwcOccasions.splice(idx, 1);
          apply();
        }, true);
      });
    }

    // --- Bind tag buttons (multi-select toggle, OR logic) ---
    function bindTags() {
      var live = root.querySelector('[data-zwc-tags-root]');
      if (!live) return;
      tagRoot = live;
      var buttons = Array.prototype.slice.call(live.querySelectorAll('[data-zwc-tag]'));
      buttons.forEach(function (btn) {
        if (btn._zwcBound) return;
        btn._zwcBound = true;
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
          var tag = slug(btn.getAttribute('data-zwc-tag'));
          var idx = root._zwcTags.indexOf(tag);
          if (idx === -1) root._zwcTags.push(tag);
          else root._zwcTags.splice(idx, 1);
          apply();
        }, true);
      });
    }

    // --- Bind Clear All / Clear links so they also wipe client-side state ---
    // These navigate to collection.url (native filter reset). Our occasion/tag
    // state persists on root, so we clear it here AND (belt-and-suspenders) on
    // any rerender that lands on a URL with no native filters (see below).
    function bindClears() {
      var clears = Array.prototype.slice.call(root.querySelectorAll('[data-zwc-clear]'));
      clears.forEach(function (el) {
        if (el._zwcClearBound) return;
        el._zwcClearBound = true;
        el.addEventListener('click', function () {
          clearAll();
        }, true);
      });
    }

    function bindButtons() {
      bindOccasion();
      bindTags();
      bindClears();
    }

    // Initial pass — if we loaded on an unfiltered URL, ensure state is empty.
    if (!hasNativeFilters()) {
      root._zwcOccasions = [];
      root._zwcTags = [];
    }
    bindButtons();
    apply();

    // --- Re-run after every AJAX native-filter swap ---
    if (!root._zwcRerenderBound) {
      root._zwcRerenderBound = true;
      document.addEventListener('zwc:rerender', function () {
        occRoot = root.querySelector('[data-zwc-occasion-root]');
        tagRoot = root.querySelector('[data-zwc-tags-root]');

        // If the swapped-in collection has NO native filters in the URL, the user
        // hit Clear All (or removed the last filter) — force client state empty so
        // occasion/tag checkboxes reset too. Otherwise keep the active selections.
        if (!hasNativeFilters()) {
          root._zwcOccasions = [];
          root._zwcTags = [];
        }

        bindButtons();
        apply();
      });
    }
  }

  /* =========================================================
     Pill × removal for client-side occasion/tag pills.
     Bound ONCE at document level in CAPTURE phase — this runs
     BEFORE zwc-collection.js's root-level pill handler, so the
     native pill AJAX logic never sees these pills. Delegation
     survives every sidebar innerHTML swap.
  ========================================================= */
  if (!document._zwcClientPillBound) {
    document._zwcClientPillBound = true;
    document.addEventListener('click', function (e) {
      var pill = e.target && e.target.closest ? e.target.closest('[data-zwc-client-pill]') : null;
      if (!pill) return;
      e.preventDefault();
      e.stopPropagation();
      var root = pill.closest('[data-zwc-root]');
      if (!root) return;
      var kind = pill.getAttribute('data-zwc-pill-kind');
      var val = slug(pill.getAttribute('data-zwc-pill-value'));
      var arr = kind === 'occasion' ? root._zwcOccasions : root._zwcTags;
      if (arr) {
        var i = arr.indexOf(val);
        if (i !== -1) arr.splice(i, 1);
      }
      if (typeof root._zwcOccApply === 'function') root._zwcOccApply();
    }, true);
  }

  function boot() {
    document.querySelectorAll('[data-zwc-root]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();